
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'
import Draw from '@/utils/draw'

export default defineComponent({
    computed: {
        ...mapState(['activityData', 'userInfo'])
    },
    emits: ['back'],
    setup (props, context) {
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $store = useStore()
        const $router = useRouter()
        const isOpening = ref<boolean>(false)
        const isOpened = ref<boolean>(false)
        const prizeData = ref<any>(null)
        const shareImgUrl = ref<string>('')
        let blessings = ($store.state.activityData.templateConfig.blessingWords || '').split('\n')
        const blessing = ref<string>(blessings[Math.floor(Math.random() * blessings.length)])

        const lottery = () => {
            _this.proxy.$request('/lottery/luck', {
                aid: $store.state.aid,
                userinfo: $store.state.userInfo
            }, 'post').then((data: any) => {
                prizeData.value = {
                    name: data.name
                }
                COVER.pageLoaded()
            }).catch((res) => {
                if (res && res.errno == 1010) {
                    $router.replace('/')
                } else {
                    COVER.pageLoaded()
                }
            })
        }

        const open = () => {
            isOpening.value = true
            setTimeout(() => {
                isOpened.value = true
            }, 3000)
        }

        const back = () => {
            context.emit('back')
        }

        const share = () => {
            if (shareImgUrl.value) {
                shareImage(shareImgUrl.value)
                return
            }
            $store.commit('SET_DIALOGDATA', {
                text: '分享图片生成中，请稍等...'
            })
            new Draw({
                resultData: {
                    blessing: blessing.value,
                    prizeName: prizeData.value ? prizeData.value.name : ''
                },
                userInfo: $store.state.userInfo,
                sucessCallback (url: string) {
                    shareImgUrl.value = url
                    shareImage(shareImgUrl.value)
                    $store.commit('SET_DIALOGDATA', null)
                },
                errCallback () {
                    $store.commit('SET_DIALOGDATA', null)
                    COVER.toast('图片生成失败，请重试！')
                }
            })
        }

        const shareImage = (url: string) => {
            COVERAPP.Method.shareImage({
                title: $store.state.shareData.title,
                desc: $store.state.shareData.desc,
                imgUrl: $store.state.shareData.imgUrl,
                link: $store.state.shareData.link,
                image: url.split(';base64,')[1],
                callback (ret: any) {
                    const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret 
                    const origin = data.origin || ''
                    if (origin != 'None' && !COVER.isEmpty(origin)) {
                        COVER.track('share', '分享图片到' + origin)
                    } else {
                        COVER.track('share', '分享图片');
                    }
                }
            })
        }

        const defaultUser = (img: string) => {
            return COVER.defaultUser(img)
        }

        onMounted(() => {
            COVER.track('load', '抽奖页面')
            COVER.onshare($store.state.shareData)
            lottery()
        })    

        return {
            isOpening,
            isOpened,
            prizeData,
            blessing,
            shareImgUrl,
            open,
            back,
            share,
            defaultUser
        }
    }
})
